module.exports = __webpack_public_path__ + "files/f35d8e4ee162608c945e268e28f8e26b.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/robotoslab-bold-webfont.woff2
 ** module id = 1011
 ** module chunks = 0
 **/